import { render, staticRenderFns } from "./StockSelector.vue?vue&type=template&id=2b895dd5"
import script from "./StockSelector.vue?vue&type=script&lang=js"
export * from "./StockSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports